import { Chip, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import { capitalizeAndKeepTheRest } from 'helpers/helpers';

import DomainIcon from './DomainIcon';

type DomainLabelProps = {
    domain: string;
    label: string;
    count: number;
};

const DomainLabel = ({ domain, label, count }: DomainLabelProps) => (
    <Stack
        direction="row"
        spacing={1}
        sx={{
            alignItems: 'center',
            py: 0.5,
        }}
    >
        <DomainIcon domain={domain} color="primary" />
        <Typography variant="body1SemiBold" sx={{ flexShrink: 0 }}>
            {capitalizeAndKeepTheRest(label)}
        </Typography>
        <Chip label={count} size="small" />
    </Stack>
);

export default DomainLabel;
